import { pathToRegexp } from 'path-to-regexp';
// 禁用部分js
export const FORBIDDEN_JS_PATH = [
  '/activity/center',
  '/about/',
  '/account/address',
  '/account/bio',
  '/account/case',
  // '/account/my-list',
  '/account/my-coupons',
  '/account/member',
  '/account/help',
  '/account/contact-us',
  '/account/profile',
  '/account/setting-language',
  '/account/settings',
  '/alcohol',
  '/pantry',
  '/pay/',
  '/logistics',
  '/support/',
  '/cms/preview'
];
/**
 * 不会出现活动弹窗的页面，活动页面本身就是活动，已经加载了组件，所以也禁止
 */
export const FORBIDDEN_ACTIVITY_PATH = FORBIDDEN_JS_PATH;

/**
 * app中新增通用的爬虫信息, 以下页面加通用的爬虫信息
 */
export const EXCLUDE_EXSIT_OPENGRAPH_PATHS = [
  '/',
  '/category/:type',
  '/review/:url',
  '/cart',
  '/about/:id',
  '/search',
  '/student-discount',
  '/account',
  '/account/address',
  '/account/affiliate',
  '/account/auto-login',
  '/account/bind-connect',
  '/account/bio',
  '/account/contact-us',
  '/account/delete-account',
  '/account/email-verification',
  '/account/follow-info',
  '/account/forget-password',
  '/account/help',
  '/account/login',
  '/account/member',
  '/account/my-coupons',
  '/account/my-list',
  '/account/notification',
  '/account/payment-card-add',
  '/account/payment-method',
  '/account/perks',
  '/account/perks-new',
  '/account/personalize-options',
  '/account/phone-connect',
  '/account/phone-verification',
  '/account/profile',
  '/account/rewards',
  '/account/setting-language',
  '/account/settings',
  '/account/signup',
  '/account/verify',
  '/account/verify-email',
  // '/brand/detail/:id',
  '/careers/career_list',
  '/cuisines',
  '/ep/:id',
  '/groceries/:type',
  '/groceries-online/:type',
  '/grocery-delivery',
  '/grocery-delivery/:type',
  '/logistics/tracking',
  '/member/share/:id',
  '/onboarding'
];

export const showCommonFacebookOgData = (path: string) => {
  let isShow = false;
  EXCLUDE_EXSIT_OPENGRAPH_PATHS.forEach(item => {
    const regexp = pathToRegexp(item);
    if (regexp.exec(path?.split('?')[0])) {
      isShow = true;
    }
  });
  return isShow;
};
